import { ICompanyAccount, IUserMDB } from '../../../lib/models/interfaces';

export const calculateComplianceCoins = (
  tokensIn: number,
  tokensOut: number,
  model?: string
) => {
  let inputFactor = 0.00135;
  let outputFactor = 0.0054;
  if (model) {
    switch (true) {
      case model === 'openai.gpt-oss-120b-1:0':
        inputFactor = 0.00015;
        outputFactor = 0.0006;
        break;
      case model ===
        'arn:aws:bedrock:us-west-2:674674125182:inference-profile/us.deepseek.r1-v1:0':
        inputFactor = 0.00135;
        outputFactor = 0.0054;
        break;
    }
  }
  const costInput = (tokensIn / 1000) * inputFactor;
  const costOutput = (tokensOut / 1000) * outputFactor;
  const totalCost = costInput + costOutput;
  const roundedUp = Math.ceil(totalCost * 10) / 10;
  // return totalCost;
  const rounded = Math.round(totalCost * 100) / 100;
  const complianceCoins = roundedUp / 0.1;
  // return complianceCoins;
  return Math.ceil(complianceCoins);
};

export const canAddSeat = (
  companyAccount: ICompanyAccount | null,
  users: IUserMDB[]
) => {
  if (!companyAccount) {
    return false;
  }
  const currentNumUsers = users.filter((ele) => !ele.deactivated).length;

  const subscription = companyAccount.subscriptions.at(-1);
};

export const priceOptions: { [key: string]: any } = {
  rogerdev: {
    pGoT: 'price_1SSijVCsMsu64ZEfVojikYxQ',
    pGo: 'price_1SSSHACsMsu64ZEfsigogGUt',
    sUser: 'price_1SSiYrCsMsu64ZEfD0Uk2lE1',
    project: 'price_1SSiajCsMsu64ZEfux1z0o2W',
    business: 'price_1SSibjCsMsu64ZEfdXSGBRaJ'
  },
  beta: {
    pGoT: 'price_1ScV6UCz2a26paxdk23db89h',
    pGo: 'price_1ScV6XCz2a26paxdlW6ehsNU',
    sUser: 'price_1ScV6WCz2a26paxdiYB5pqPl',
    project: 'price_1ScV6WCz2a26paxdSAMy12Vq',
    business: 'price_1ScV6VCz2a26paxdsmoZAcKJ'
  },
  prod: {
    pGoT: 'price_1ScX0FCbNsFOwWd0YHYqsjgY',
    pGo: 'price_1ScX0HCbNsFOwWd0sKWNAxGr',
    sUser: 'price_1ScX0HCbNsFOwWd0eaPHz3WV',
    project: 'price_1ScX0HCbNsFOwWd02G7BPExl',
    business: 'price_1ScX0GCbNsFOwWd02CoUej9C'
  }
};
